import React from "react";
import {MessageBarType, Stack} from "@fluentui/react";
import {useTranslation} from "react-i18next";

import styles from "./constructionCalculationsNew.module.scss"
import ConstructionCalculationsNewHeader from "./components/header/ConstructionCalculationsNewHeader";
import ConstructionCalculationsNewBody from "./components/body/ConstructionCalculationsNewBody";
import ConstructionCalculationsNewPanel from "./components/sidePanel/ConstructionCalculationsNewPanel";
import ConfirmConstructionStateChangeModalNew from "./components/modal/ConfirmConstructionStateChangeModalNew";
import IsaacLoading from "../../components/isaacLoading/IsaacLoading";
import IsaacMessageBar from "../../components/isaacMessageBar/IsaacMessageBar";
import useConstructionCalculationsPageHookOrchestrator from "./hooks/useConstructionCalculationsPageHookOrchestrator";

const ConstructionCalculationsNew: React.FunctionComponent = () => {
  const {
    loading,
    construction,
    calculations,
    selectedMastNo,
    selectedCalculationResults,
    constructionDetails,
    isAllowToTakeAction,
    sideMenuOpen,
    confirmationModalOpen,
    commandBarItems,
    commandBarFarItems,
    errors,
    handleSideMenuOpenState,
    handleConfirm,
    handleDismiss,
  } = useConstructionCalculationsPageHookOrchestrator();

  const {t} = useTranslation(["constructionCalculations"]);

  return (
    <>
      <IsaacLoading
        loading={loading}
        message="Loading construction calculation..."
      />
      {!loading && construction && (
        <Stack className={styles.bodyStack}>
          <Stack.Item>
            <ConstructionCalculationsNewHeader
              commandBarItems={commandBarItems}
              commandBarFarItems={commandBarFarItems}
              calculations={calculations}
              construction={construction}
              selectedCalculationResults={selectedCalculationResults}
            />
          </Stack.Item>

          {!errors && (
            <Stack.Item>
              <ConstructionCalculationsNewBody
                selectedMastNo={selectedMastNo}
                construction={construction}
                constructionDetails={constructionDetails}
                calculationResults={selectedCalculationResults}
              />
            </Stack.Item>
          )}

          <ConstructionCalculationsNewPanel
            open={sideMenuOpen}
            setCalculationPanelState={handleSideMenuOpenState}
            calculations={calculations}
            isAllowToTakeAction={isAllowToTakeAction}
          />
          <ConfirmConstructionStateChangeModalNew
            open={confirmationModalOpen}
            status={construction.status}
            handleConfirm={handleConfirm}
            handleDismiss={handleDismiss}
          />
          {errors && (
            <IsaacMessageBar
              className={styles.errorMsg}
              messageBarType={MessageBarType.error}>
              <>
                <div className={styles.errorMsgHeader}>
                  {t("matLabErrorMessage")}:
                </div>
                <div>{JSON.stringify(errors, null, 4)}</div>
              </>
            </IsaacMessageBar>
          )}
        </Stack>
      )}
    </>
  );
};

export default ConstructionCalculationsNew;
